import { __awaiter } from "tslib";
import Middleware from '../middleware/index';
import { CLIENT_TYPE } from './clientType';
import { isMMP, isMHotel, isDouYin, isQuickApp, isDianPing, isDianPingMerchant, isDaXiang, isTripbiz, isWXMiniProgram, isWechat, isXueXiQiangGuo, isAlipay, isNewsArticle, isCrowdsourceAndroid, isCrowdsourceIOS, isDeliveryAndroid, isDeliveryIOS, isConch, isMaoYan, isMaiCai, isXiaoXiang, isMerchant, isMTYXApp, isMTLiveAnchor, isErpBossPro, isBaiChuan, isWaiMaiApp, isMeiTuan, isWaiMaiMerchantApp } from './ua';
export { CLIENT_TYPE };
export * from './ua';
/**
* 门票App
* @param ctx
* @param next
* @returns
*/
const tripbizContainer = (ctx, next) => {
    const { ua } = ctx;
    if (isTripbiz(ua)) {
        return CLIENT_TYPE.tripbiz; // 门票App
    }
    return next();
};
/**
 * 未知容器
 * @param _ctx
 * @param _next
 * @returns
 */
const unknown = (_ctx, _next) => CLIENT_TYPE.unknown;
/**
 * 美团小程序
 * @param ctx
 * @param next
 * @returns
 */
const mmpContainer = (ctx, next) => {
    const { ua } = ctx;
    if (isMMP(ua)) {
        return CLIENT_TYPE.mmp; // 美团小程序
    }
    return next();
};
/**
 * 微信小程序
 * @param ctx
 * @param next
 * @returns
 */
const weixinAppContainer = (ctx, next) => {
    const { ua } = ctx;
    if (isWXMiniProgram(ua)) {
        return CLIENT_TYPE.weixinapp; // 微信小程序
    }
    return next();
};
const weixinContainer = (ctx, next) => {
    const { ua } = ctx;
    if (isWechat(ua)) {
        return CLIENT_TYPE.weixin; // 微信
    }
    return next();
};
/**
 * 学习强国
 * @param ctx
 * @param next
 * @returns
 */
const xuexiqgContainer = ({ ua }, next) => isXueXiQiangGuo(ua)
    ? CLIENT_TYPE.xuexiqg : next(); // 学习强国
const alipayContainer = ({ ua }, next) => isAlipay(ua)
    ? CLIENT_TYPE.alipay : next(); // 支付宝
const newsarticleContainer = ({ ua }, next) => {
    if (isNewsArticle(ua)) {
        return CLIENT_TYPE.newsarticle; // 今日头条
    }
    return next();
};
const douyinContainer = ({ ua }, next) => {
    if (isDouYin(ua)) {
        return CLIENT_TYPE.douyin; // 抖音
    }
    return next();
};
/**
 * 快应用容器，包括：华为、小米、vivo、oppo
 * @param param0
 * @param next
 * @returns
 */
const quickAppContainer = ({ ua }, next) => {
    if (isQuickApp(ua)) {
        return CLIENT_TYPE.mtquickapp;
    }
    return next();
};
const dpmerchantContainer = ({ ua }, next) => {
    if (isDianPingMerchant(ua)) {
        return CLIENT_TYPE.dpmerchant; // 点评管家
    }
    return next();
};
const dianpingContainer = ({ ua }, next) => {
    if (isDianPing(ua)) {
        return CLIENT_TYPE.dianping; // 点评
    }
    return next();
};
const mwaimaiContainer = ({ ua }, next) => {
    if (isWaiMaiMerchantApp(ua)) {
        return CLIENT_TYPE.mwaimai; // 外卖商家端
    }
    return next();
};
/**
 * 外卖App
 * @param ctx
 * @param next
 * @returns
 */
const wmContainer = (ctx, next) => {
    const { query, ua } = ctx;
    if (isWaiMaiApp(ua, query)) {
        return CLIENT_TYPE.waimai;
    }
    return next();
};
const crowdsourceContainer = ({ ua }, next) => {
    if (isCrowdsourceAndroid(ua)) {
        return CLIENT_TYPE.crowdsource; // 美团众包
    }
    return next();
};
const ioscrowdsourceContainer = ({ ua }, next) => {
    if (isCrowdsourceIOS(ua)) {
        return CLIENT_TYPE.ioscrowdsource; // 美团众包ios端
    }
    return next();
};
const deliveryContainer = ({ ua }, next) => {
    if (isDeliveryAndroid(ua)) {
        return CLIENT_TYPE.delivery; // 美团配送
    }
    return next();
};
const iosdeliveryContainer = ({ ua }, next) => {
    if (isDeliveryIOS(ua)) {
        return CLIENT_TYPE.iosdelivery; // 美团配送ios端
    }
    return next();
};
const conchContainer = ({ ua }, next) => {
    if (isConch(ua)) {
        return CLIENT_TYPE.conch; // 钱包
    }
    return next();
};
const mhotelContainer = ({ ua }, next) => {
    if (isMHotel(ua)) {
        return CLIENT_TYPE.mhotel; // 美酒
    }
    return next();
};
const maoyanContainer = ({ ua }, next) => {
    if (isMaoYan(ua)) {
        return CLIENT_TYPE.maoyan; // 猫眼
    }
    return next();
};
const daxiangContainer = ({ ua }, next) => {
    if (isDaXiang(ua)) {
        return CLIENT_TYPE.daxiang; // 大象
    }
    return next();
};
const maicaiContainer = ({ ua }, next) => {
    if (isMaiCai(ua)) {
        return CLIENT_TYPE.maicai; // 买菜
    }
    return next();
};
const xiaoxiangContainer = ({ ua }, next) => {
    if (isXiaoXiang(ua)) {
        return CLIENT_TYPE.xiaoxiang; // 小象
    }
    return next();
};
const kaidianbaoContainer = ({ ua }, next) => {
    if (isMerchant(ua)) {
        return CLIENT_TYPE.ecomapp; // 开店宝
    }
    return next();
};
/**
 * 美团容器，但不包含快应用和mmp(美团小程序容器)
 * @param param0
 * @param next
 * @returns
 */
const meituanContainer = ({ ua }, next) => {
    if (isMeiTuan(ua)) {
        return CLIENT_TYPE.meituan; // 美团
    }
    return next();
};
const mtyxAppContainer = ({ ua }, next) => {
    if (isMTYXApp(ua)) {
        return CLIENT_TYPE.mtyxapp; // 美团优选App
    }
    return next();
};
/**
 * 美团直播助手App
 * @param param0
 * @param next
 * @returns
 */
const mtLiveAnchorAppContainer = ({ ua }, next) => {
    if (isMTLiveAnchor(ua)) {
        return CLIENT_TYPE.mtliveanchor; // 美团直播助手App
    }
    return next();
};
const erpBossProContainer = ({ ua }, next) => {
    if (isErpBossPro(ua)) {
        return CLIENT_TYPE.erpbosspro; // 美团管家智能版
    }
    return next();
};
const baiChuanContainer = ({ ua }, next) => {
    if (isBaiChuan(ua)) {
        return CLIENT_TYPE.baichuan; // 百川App
    }
    return next();
};
const createClientTypePipe = () => {
    const md = new Middleware();
    return md.use([
        mtyxAppContainer,
        erpBossProContainer,
        mmpContainer,
        quickAppContainer,
        weixinAppContainer,
        weixinContainer,
        xuexiqgContainer,
        alipayContainer,
        newsarticleContainer,
        douyinContainer,
        dpmerchantContainer,
        dianpingContainer,
        mwaimaiContainer,
        wmContainer,
        crowdsourceContainer,
        ioscrowdsourceContainer,
        deliveryContainer,
        iosdeliveryContainer,
        conchContainer,
        baiChuanContainer,
        mhotelContainer,
        maoyanContainer,
        daxiangContainer,
        maicaiContainer,
        xiaoxiangContainer,
        tripbizContainer,
        kaidianbaoContainer,
        mtLiveAnchorAppContainer,
        meituanContainer,
        unknown
    ]);
};
/**
 * 获取客服端容器类型
 * @param ua
 * @param query
 * @returns
 */
export const getClientType = (ua, query = {}) => __awaiter(void 0, void 0, void 0, function* () {
    const md = createClientTypePipe();
    const ctx = {
        ua,
        query
    };
    return md.dispatch(ctx);
});
/**
 * 获取客服端容器类型
 * @param ua
 * @param query
 * @returns
 */
export const getClientTypeSync = (ua, query = {}) => {
    const md = createClientTypePipe();
    const ctx = {
        ua,
        query
    };
    return md.dispatchSync(ctx);
};
